import { render } from "./ApprovalProcessManagement.vue?vue&type=template&id=088021d5&scoped=true"
import script from "./ApprovalProcessManagement.vue?vue&type=script&lang=js"
export * from "./ApprovalProcessManagement.vue?vue&type=script&lang=js"

import "./ApprovalProcessManagement.vue?vue&type=style&index=0&id=088021d5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-088021d5"]])

export default __exports__